import router from '@/router';
import axios from 'axios';
import { isTokenExpired, destroyToken } from './jwt.service';

export const tokenPromise = new Promise((resolve, reject) => {
  if (isTokenExpired()) {
    reject(new Error('Token Expired'));
  } else {
    resolve();
  }
}).catch(() => {
  destroyToken();
  router.push({ name: 'Login' });
});

export function getApi(resource) {
  return tokenPromise.then(() => axios.get(resource));
}

export function queryApi(resource, params) {
  return tokenPromise.then(() => axios.get(resource, { params }));
}

export function updateApi(resource, params) {
  return tokenPromise.then(() => axios.patch(resource, params));
}

export function deleteApi(resource) {
  return tokenPromise.then(() => axios.delete(resource));
}

export function createApi(resource, params) {
  return tokenPromise.then(() => axios.post(resource, params));
}

export function get(resource, slug, params = {}) {
  return tokenPromise.then(() => {
    return axios.get(`${resource}/${slug}`, { params })
      .catch((error) => {
        throw new Error(`ApiService (${resource}/${slug}) ${error}`);
      });
  });
}

export function query(resource, params = {}) {
  return tokenPromise.then(() => {
    return axios.get(resource, { params })
      .catch((error) => {
        throw new Error(`ApiService (${resource}) ${error}`);
      });
  });
}

export function update(resource, slug, params) {
  return tokenPromise.then(() => {
    return axios.patch(`${resource}/${slug}`, { data: { attributes: params } })
      .catch((error) => {
        throw new Error(`ApiService (${resource}/${slug}) ${error}`);
      });
  });
}

export function destroy(resource) {
  return tokenPromise.then(() => {
    return axios.delete(resource)
      .catch((error) => {
        throw new Error(`ApiService (${resource}) ${error}`);
      });
  });
}

export function create(resource, params) {
  return tokenPromise.then(() => axios.post(resource, params));
}

export function post(resource, params) {
  return tokenPromise.then(() => {
    return axios.post(`${resource}`, { data: { attributes: params } })
      .catch((error) => {
        throw new Error(`ApiService (${resource}) ${error}`);
      });
  });
}

export default {
  getApi,
  updateApi,
  queryApi,
  deleteApi,
  createApi,
  get,
  query,
  create,
  update,
  destroy,
  post,
};
